import React from "react";
import "./Section2.css";
import Shape1 from "../../../../../assets/images/dataintegrity-shape1.png";
import Shape2 from "../../../../../assets/images/dataintegrity-shape2.png";
import Shape3 from "../../../../../assets/images/dataintegrity-shape3.png";
import Dots from "../../../../../assets/images/aboutus-dots.png";
const Section2 = () => {
  return (
    <div className="taxreturnssrsec2_section">
      <img src={Shape1} alt="" className="taxreturnssrsec2_shape1" />
      <img src={Shape2} alt="" className="taxreturnssrsec2_shape2" />
      <img src={Shape3} alt="" className="taxreturnssrsec2_shape3" />
      <img src={Dots} alt="" className="taxreturnssrsec2_dots" />
      <div className="taxreturnssrsec2_heading">
        Return Preparation and Filing Process
      </div>
      <div className="taxreturnssrsec2_description">
        Whether you rushed to finish your taxes and may have caused a mistake,
        or were unaware of exemptions you could have claimed, filing an amended
        tax return is your option. Don’t feel too bad. You are not alone. There
        are millions who have or faced the same situation as yours.
      </div>
      <div className="taxreturnssrsec2_description">
        However, you can choose us to be your expert in handling your case. Your
        tax return will be checked and rechecked by our professional team
        identifying potential problems the IRS may look at more closely and
        reviewing the math to limit IRS contacts. we provide to the transfer of
        our knowledge. We believe that the more we educate our clients, the
        stronger our relationships with them become.
      </div>
    </div>
  );
};

export default Section2;
